module.exports = __webpack_public_path__ + "img/single_value_chart.bec73a88.svg";